(function () {
  'use strict';
  if (window.SRCarousel) return;

  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var drag = null;
  var suppressClick = false;
  var scheduled = false;

  function behavior() {
    return reduced.matches ? 'auto' : 'smooth';
  }

  function maxScroll(track) {
    return Math.max(0, track.scrollWidth - track.clientWidth);
  }

  function items(track) {
    return Array.prototype.filter.call(track.children, function (item) {
      return item.offsetWidth > 0;
    });
  }

  function startPadding(track) {
    var style = window.getComputedStyle(track);
    var value = parseFloat(style.scrollPaddingLeft);
    return isNaN(value) ? parseFloat(style.paddingLeft) || 0 : value;
  }

  function snapTarget(track) {
    var list = items(track);
    if (!list.length) return track.scrollLeft;
    var origin = track.getBoundingClientRect().left + startPadding(track);
    var best = track.scrollLeft;
    var distance = Infinity;
    list.forEach(function (item) {
      var offset = item.getBoundingClientRect().left - origin;
      if (Math.abs(offset) < distance) {
        distance = Math.abs(offset);
        best = track.scrollLeft + offset;
      }
    });
    return Math.max(0, Math.min(maxScroll(track), best));
  }

  function pageStep(track) {
    var list = items(track);
    if (list.length < 2) return track.clientWidth;
    var unit = list[1].getBoundingClientRect().left - list[0].getBoundingClientRect().left;
    if (unit <= 0) return track.clientWidth;
    return Math.max(unit, Math.floor((track.clientWidth - startPadding(track)) / unit) * unit);
  }

  function refresh(track) {
    if (!track.id) return;
    var max = maxScroll(track);
    var visible = !track.hidden && track.offsetParent !== null;
    document.querySelectorAll('[data-sr-carousel-arrows="' + track.id + '"]').forEach(function (group) {
      group.hidden = !visible || max <= 2;
      var prev = group.querySelector('[data-sr-carousel-prev]');
      var next = group.querySelector('[data-sr-carousel-next]');
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    });
  }

  function refreshAll() {
    document.querySelectorAll('[data-sr-carousel]').forEach(refresh);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      refreshAll();
    });
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('[data-sr-carousel]')) refresh(target);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
        return;
      }
      var button = event.target.closest && event.target.closest('[data-sr-carousel-prev], [data-sr-carousel-next]');
      if (!button) return;
      var track = document.getElementById(button.getAttribute('aria-controls'));
      if (!track) return;
      event.preventDefault();
      var direction = button.hasAttribute('data-sr-carousel-next') ? 1 : -1;
      track.scrollBy({ left: direction * pageStep(track), behavior: behavior() });
    },
    true
  );

  document.addEventListener('dragstart', function (event) {
    if (desktop.matches && event.target.closest && event.target.closest('[data-sr-carousel]')) event.preventDefault();
  });

  document.addEventListener('selectstart', function (event) {
    if (drag) event.preventDefault();
  });

  document.addEventListener('pointerdown', function (event) {
    if (!desktop.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
    var track = event.target.closest && event.target.closest('[data-sr-carousel]');
    if (!track || maxScroll(track) <= 2) return;
    if (event.target.closest('button, input, select, textarea, label')) return;
    drag = {
      track: track,
      pointerId: event.pointerId,
      startX: event.clientX,
      startLeft: track.scrollLeft,
      moved: false,
    };
  });

  window.addEventListener('pointermove', function (event) {
    if (!drag || event.pointerId !== drag.pointerId) return;
    var dx = event.clientX - drag.startX;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return;
      drag.moved = true;
      drag.track.classList.add('is-dragging');
      try {
        drag.track.setPointerCapture(event.pointerId);
      } catch (error) {}
    }
    event.preventDefault();
    drag.track.scrollLeft = drag.startLeft - dx;
  });

  function endDrag(event) {
    if (!drag || (event && event.pointerId !== drag.pointerId)) return;
    var current = drag;
    drag = null;
    if (!current.moved) return;
    var track = current.track;
    suppressClick = true;
    window.setTimeout(function () {
      suppressClick = false;
    }, 0);
    try {
      track.releasePointerCapture(current.pointerId);
    } catch (error) {}
    track.scrollTo({ left: snapTarget(track), behavior: behavior() });
    window.setTimeout(function () {
      track.classList.remove('is-dragging');
      refresh(track);
    }, reduced.matches ? 0 : 420);
  }

  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });

  schedule();

  window.SRCarousel = { refresh: refreshAll };
})();
